import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'SDQTeacher',
    label: 'SDQTeacher',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
